<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction"></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
    >
      <el-table-column prop="CustomerOrderId" label="订单号"></el-table-column>
      <el-table-column type="expand" width="40">
        <template slot-scope="scope">
          <el-table
            border
            :data="scope.row.OrderList"
            show-summary
            style="width: 1000px"
            size="mini"
          >
            <el-table-column :label="$t('Enabled')" width="125">
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  :class="'text_white state' + scope.row.Status"
                  disable-transitions
                  >{{ $t("Order.StatusList")[scope.row.Status] }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column :label="$t('Order.OrderNo')" width="170">
              <template slot-scope="scope"
                >{{ scope.row.OrderNo }}（{{ scope.row.TakeNo }}）</template
              >
            </el-table-column>
            <el-table-column label="订单合计" width="90">
              <template slot-scope="scope">
                <span class="text_red"
                  >${{ (scope.row.Total + scope.row.Freight).toFixed(2) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="实际支付" width="90">
              <template slot-scope="scope">
                <span class="text_red"
                  >$
                  {{
                    (
                      scope.row.Total -
                      scope.row.KoipyDeduct +
                      scope.row.Freight
                    ).toFixed(2)
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="配送时间" width="250">
              <template slot-scope="scope"
                >{{ formatDate(scope.row.ShippingDate) }}
                {{ scope.row.ShippingTime.Name }}：{{
                  scope.row.ShippingTime.StartTime
                }}~{{ scope.row.ShippingTime.EndTime }}</template
              >
            </el-table-column>
            <el-table-column prop="PayType" :label="$t('PayMode')" width="90">
              <template slot-scope="scope">{{
                $t("Order.PayType." + scope.row.PayType)
              }}</template>
            </el-table-column>
            <el-table-column
              label="收货人"
              prop="Consignee"
              width="130"
            ></el-table-column>
            <el-table-column
              label="联系电话"
              prop="Phone"
              width="100"
            ></el-table-column>
            <el-table-column
              label="收货地址"
              prop="Address"
              width="250"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="邮编"
              prop="ZipCode"
              width="70"
            ></el-table-column>
            <el-table-column
              label="备注"
              prop="Remark"
              width="300"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="配送状态" width="120">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :class="'psstate' + scope.row.Status"
            effect="plain"
            >{{ $t("Express.StatusList")[scope.row.Status] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('Shop.Name')">
        <template slot-scope="scope">{{
          field(scope.row.ShopConfig.Name)
        }}</template>
      </el-table-column>
      <el-table-column label="金额" width="90">
        <template slot-scope="scope">
          <span class="text_red">${{ scope.row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约时间">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.ScheduleAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="OrderRef"
        label="OrderRef"
        width="280"
      ></el-table-column>
      <el-table-column
        :label="$t('Order.SubmitTime')"
        prop="DateTime"
        width="130"
        fixed="right"
      >
        <template slot-scope="scope">{{
          formatDateTime(scope.row.Created)
        }}</template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "util/date";
import { getExpressList } from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    formatDateTime: function (val) {
      if (val == null) {
        return "";
      }
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;
      getExpressList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style scoped>
.state101 {
  background-color: mediumblue !important;
}
.state102 {
  background-color: rgb(255, 115, 0) !important;
}
.state201 {
  background-color: orange !important;
}

.state202 {
  background-color: lightcoral !important;
}

.state203 {
  background-color: lightcoral !important;
}

.state204 {
  background-color: lightcoral !important;
}

.state300 {
  background-color: limegreen !important;
}

.state401 {
  background-color: darkgray !important;
}

.state402 {
  background-color: tomato !important;
}

.state403 {
  background-color: darkgray !important;
}
.psstate1 {
  color: tomato !important;
  border-color: tomato !important;
}
.psstate2,
.psstate4,
.psstate6 {
  color: limegreen !important;
  border-color: limegreen !important;
}
.psstate3,
.psstate5,
.psstate7 {
  color: darkgray !important;
  border-color: darkgray !important;
}
</style>
